const roles = {
  RESPONSIBLE_OR_AUTHOR: "RESPONSIBLE_OR_AUTHOR",
  APPOINTED_WORKER: "APPOINTED_WORKER",
}

export default roles;